import Text from "../../../Components/Text/Text";
import BrowserIcon from "../../../assets/svgs/browser.svg";
import StartupIcon from "../../../assets/svgs/start-up.svg";
import { useEffect, useRef, useState } from "react";
import { useWindowScroll } from "../../../hooks/useWindowScroll";

const MODELS = [
  {
    title: "API Development",
    subTitle: "Create more opportunities by building APIs for your business",
    description:
      "APIs are the path to new business opportunities. Be prepared for the opportunities that knocks on your door with ready APIs. Make your organisation the choice company your businesses want to work with.",
    image: BrowserIcon,
  },
  {
    title: "Drive Your Business Forward",
    subTitle: "Integrating legacy systems with modern applications",
    description:
      "You legacy system maybe a critical part of your day to day operations and it might be an enormous effort and cannot take the risk of a total digital transformation. In this case, an integration between systems would be a safer choice.",
    image: StartupIcon,
  },
];

export default function AppoachSection() {
  const ref = useRef();
  const { y, height } = useWindowScroll();

  const { offsetTop: elOffsetTop } = ref?.current || {};
  const boundary = elOffsetTop - height / 1.5;
  const show = y > boundary;

  return (
    <section ref={ref} className="pt-24 overflow-hidden">
      <ul className="container flex flex-col md:flex-row pt-12 gap-12 justify-between mx-auto">
        {MODELS.map((item, index) => (
          <Item key={item.title} {...item} show={show} index={index} />
        ))}
      </ul>
    </section>
  );
}

function Item({ title, image, index, show, description, subTitle }) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const time = show ? index * 200 : 0;
    const timeId = setTimeout(() => setActive(show), time);
    return () => clearTimeout(timeId);
  }, [show, index]);

  return (
    <li
      className={`flex-1 transition-all flex justify-center duration-700 py-24 px-4 ${
        active ? "" : "opacity-0 translate-y-96"
      }`}
    >
      <div>
        <img
          loading="lazy"
          className="aspect-square w-[150px] object-cover"
          src={image}
          alt={title}
        />
        <Text className="mt-8 mb-4 block font-semibold" size="lg">
          {title}
        </Text>
        <Text className="mt-4 mb-8 block max-w-[600px] font-semibold" size="md">
          {subTitle}
        </Text>
        <Text className="block max-w-[600px]">{description}</Text>
      </div>
    </li>
  );
}
